<template>
  <div>
    <!-- START MAIN CONTENT -->
    <div class="main_content">
      <!-- START SECTION SHOP -->
      <div class="section">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-6">
              <div class="heading_s3 text-center">
                <h2 class="text-warning">Dịch Vụ</h2>
              </div>
              <div class="small_divider clearfix"></div>
            </div>
          </div>
          <div class="row" v-if="services.length > 0">
            <div
              class="col-lg-3 col-md-4 col-6"
              v-for="(service, index) in services"
              :key="index"
            >
              <div class="product_box text-center">
                <div class="product_img">
                  <a
                    v-if="service.thumbnail"
                    :href="
                      route('fe_service.detail', {
                        domain: website.domain,
                        service_slug: service.slug,
                      })
                    "
                    target="_blank"
                  >
                    <img
                      class="card-img-top fit-contain"
                      :src="service.thumbnail"
                      :alt="service.title"
                      :height="152"
                      :width="253"
                    />
                  </a>
                </div>
                <div class="product_info">
                  <h6 class="product_title">
                    <a
                      :href="
                        route('fe_service.detail', {
                          domain: website.domain,
                          service_slug: service.slug,
                        })
                      "
                      target="_blank"
                    >
                      <span class="col"
                        ><b>{{ service.title }}</b></span
                      >
                    </a>
                  </h6>
                  <div class="pr_desc">
                    <a
                      class="btn btn-fill-out btn-radius"
                      :href="
                        route('fe_service.detail', {
                          domain: website.domain,
                          service_slug: service.slug,
                        })
                      "
                    >
                      Nạp Ngay
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- END SECTION SHOP -->
  </div>
</template>
<script>
export default {
  name: "ServiceList",
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      },
    },
    services: {
      Type: Object,
      data() {
        return {};
      },
    },
    website: {
      Type: Object,
      data() {
        return {};
      },
    },
  },
};
</script>
